function Calender () {
    return (
        <div style={{ width: "100%", height: "100%" }}>
            <iframe style={{ width: "90%", maxWidth: "64em", border:0, minHeight: "512px", height: "100%", aspectRatio: 4/3 }} title="map" src="https://calendar.google.com/calendar/embed?src=dctrlmedia%40gmail.com&ctz=America%2FVancouver"></iframe>
        </div>
    )
}

export default Calender;
